// @ts-nocheck
import { create } from 'zustand';
import { getDatabase, onValue, ref } from 'firebase/database';
import useAuthStore from './auth';

const useRealtimeStore = create((set, get) => ({
  loading: { bindRealtimeData: false },
  data: { currentSessions: 0 },
  _realtimeRef: null,

  reset: () => set({
    loading: { bindRealtimeData: false },
    data: { currentSessions: 0 },
  }),

  bindRealtimeData: () => new Promise((resolve, reject) => {
    let initialCall = false;
    const timeout = setTimeout(() => reject(new Error('Timeout error; exceeded 10s')), 10000);

    let node = get()._realtimeRef;
    if (!node) {
      const { clientId } = useAuthStore.getState().user;
      if (!clientId) {
        // No clientId yet (claims may not have propagated from the backend).
        // Resolve quietly — the dashboard renders without realtime sessions
        // and a future mount once user state is hydrated will succeed.
        clearTimeout(timeout);
        resolve(false);
        return;
      }
      node = ref(getDatabase(), `realtimeData/${clientId}`);
      set({ _realtimeRef: node });
    }

    onValue(
      node,
      (snapshot) => {
        set((s) => ({ data: { ...s.data, ...(snapshot.val() || {}) } }));
        if (!initialCall) {
          initialCall = true;
          resolve(true);
          clearTimeout(timeout);
        }
      },
      (error) => {
        clearTimeout(timeout);
        // Reset cached ref so a retry can re-attempt.
        set({ _realtimeRef: null });
        reject(error);
      },
    );
  }),
}));

export default useRealtimeStore;
